/**
 * @file pascalCase Convert str into pascal case.
 * @author yuzong(yuzong@tencent.com)
 */
import { camelCase } from './camelCase';
/**
 * Convert str into pascal case.
 *
 * eg: 'foo-bar' => 'FooBar'
 *
 * @param str The str which will be convert.
 * @param prefix The connection chars of the original string, '-' by default.
 */

export function pascalCase(str) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  str = camelCase(str, prefix);
  return "".concat(str[0].toUpperCase()).concat(str.slice(1));
}